module.exports = __webpack_public_path__ + "img/fendanyun_05.1ed1b0f7.jpg";